import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getSecondaryMachineIdKey } from "../queryKeys";
import api from "../api";
import { show } from "../../../notifications/notifications";
import { NotificationsLevel } from "../../../lib/enums";

const useSecondaryLicensingId = () => {
  const {
    data: secondaryLicensingId,
    isPending,
    isError
  } = useQuery({
    queryKey: getSecondaryMachineIdKey,
    queryFn: api.getSecondaryLicensingId
  });

  useEffect(() => {
    if (isError) {
      show({
        level: NotificationsLevel.ERROR,
        message: "Error while fetching secondary machine key..."
      });
    }
  }, [isError]);

  return { secondaryLicensingId, isLoading: isPending };
};

export default useSecondaryLicensingId;
